import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  constructor(
    private toastr: ToastrService,
    private translocoService: TranslocoService
  ) { }

  success(message: string) {
    this.toastr.success(message);
  }
  error(message: string) {
    this.toastr.error(message);
  }

  warning(message: string) {
    this.toastr.warning(message);
  }
}
